


















import { Component, Prop, Vue } from 'vue-property-decorator';
import Title from '../title';

@Component({
  components: {
    Title,
  },
})
export default class Files extends Vue {
  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: Array, default: () => [] })
  readonly files!: Array<any>;

  get nameAndUrl() {
    return this.files.filter(({ name, url }) => name.length && url.length);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/itemsblock/components/files/Files.vue